(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Sort sold-out products to the end of the grid
  function sortSoldOutLast(list) {
    const items = Array.from(list.querySelectorAll(':scope > li[data-available]'));
    const inStock = items.filter((i) => i.dataset.available !== 'false');
    const soldOut = items.filter((i) => i.dataset.available === 'false');
    if (!soldOut.length) return;
    [...inStock, ...soldOut].forEach((i) => list.appendChild(i));
  }

  function initSoldOutSort() {
    const list = document.querySelector('.product-grid');
    if (!list) return;
    sortSoldOutLast(list);
    let sorting = false;
    new MutationObserver(() => {
      if (sorting) return;
      sorting = true;
      requestAnimationFrame(() => {
        sortSoldOutLast(list);
        sorting = false;
      });
    }).observe(list, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSoldOutSort);
  } else {
    initSoldOutSort();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-fit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root._fitBound) return;
      root._fitBound = true;

      var msg = root.querySelector('[data-fit-msg]');
      var cta = root.querySelector('[data-fit-add]');

      root.querySelectorAll('[data-fit-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('.the-fit__item');
          group.querySelectorAll('[data-fit-size]').forEach(function (b) {
            b.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('aria-pressed', 'true');
          group.querySelector('[data-fit-variant]').value = btn.dataset.variant;
          group.classList.remove('the-fit__item--missing');
          if (msg) { msg.textContent = ''; msg.classList.remove('the-fit__msg--error'); }
        });
      });

      cta.addEventListener('click', function () {
        var items = [];
        var missing = false;

        var firstMissing = null;
        root.querySelectorAll('.the-fit__item').forEach(function (item) {
          var input = item.querySelector('[data-fit-variant]');
          if (!input) return;
          item.classList.remove('the-fit__item--missing');
          if (!input.value) {
            if (input.dataset.required === 'true') {
              missing = true;
              item.classList.add('the-fit__item--missing');
              if (!firstMissing) firstMissing = item;
            }
            return;
          }
          items.push({ id: Number(input.value), quantity: 1 });
        });

        if (missing) {
          if (msg) {
            msg.textContent = 'Pick a size first.';
            msg.classList.add('the-fit__msg--error');
          }
          if (firstMissing) firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (msg) msg.classList.remove('the-fit__msg--error');
        if (!items.length) return;

        var label = cta.textContent;
        cta.disabled = true;
        cta.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Sold out'); });
            return r.json();
          })
          .then(function (data) {
            cta.textContent = 'Added';
            if (msg) msg.textContent = 'Cap added free. Check your bag.';
            document.dispatchEvent(new CustomEvent('CartAddEvent', {
              bubbles: true,
              detail: { items: data.items }
            }));
            setTimeout(function () { cta.disabled = false; cta.textContent = label; }, 2000);
          })
          .catch(function (err) {
            cta.disabled = false;
            cta.textContent = label;
            if (msg) msg.textContent = err.message || 'Something went wrong.';
          });
      });
    }

    function boot() {
      document.querySelectorAll('[data-the-fit]').forEach(init);
    }

    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
